/**
 * Human-readable bit rate: 2.62 Gbps, 59.0 Mbps, 812 Kbps, 0 bps.
 *
 * Base is 1000 (decimal SI), which is the correct base for bits/sec — link
 * speeds and interface counters are quoted decimally (1 Gbps = 1e9 bps).
 *
 * The carry check uses the *rounded* value so a rate just under a boundary
 * steps up instead of printing "1000 Kbps" (e.g. 999999 -> "1 Mbps").
 */
export function formatBps(bps: number | null | undefined): string {
  if (bps === null || bps === undefined || !Number.isFinite(bps)) return "—";
  const units = ["bps", "Kbps", "Mbps", "Gbps", "Tbps"];
  let v = Math.abs(bps);
  let i = 0;
  while (i < units.length - 1 && Number(v.toPrecision(3)) >= 1000) {
    v /= 1000;
    i++;
  }
  const digits = v === 0 || i === 0 ? String(Math.round(v)) : Number(v.toPrecision(3)).toString();
  return `${digits} ${units[i]}`;
}
